import { cva } from 'class-variance-authority';

/**
 * Button style variants. Kept in its own module so `Button.tsx` only exports the
 * component (keeps React Fast Refresh happy).
 */
export const buttonVariants = cva(
  // Base styles
  [
    'inline-flex items-center justify-center gap-2 rounded-md font-medium',
    'transition-colors focus-visible:outline-none focus-visible:ring-2',
    'focus-visible:ring-safety-500 focus-visible:ring-offset-2 focus-visible:ring-offset-graphite-950',
    'disabled:pointer-events-none disabled:opacity-50',
    'min-h-touch', // Touch-friendly minimum height
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-safety-500 text-white',
          'hover:bg-safety-600',
          'active:bg-safety-700',
        ],
        secondary: [
          'bg-graphite-700 text-graphite-100',
          'hover:bg-graphite-600',
          'active:bg-graphite-500',
        ],
        outline: [
          'border border-graphite-600 bg-transparent text-graphite-100',
          'hover:bg-graphite-800 hover:border-graphite-500',
          'active:bg-graphite-700',
        ],
        ghost: [
          'bg-transparent text-graphite-300',
          'hover:bg-graphite-800 hover:text-graphite-100',
          'active:bg-graphite-700',
        ],
        destructive: [
          'bg-danger-500 text-white',
          'hover:bg-danger-600',
          'active:bg-danger-700',
        ],
        success: [
          'bg-signal-500 text-white',
          'hover:bg-signal-600',
          'active:bg-signal-700',
        ],
      },
      size: {
        sm: 'h-9 px-3 text-sm',
        md: 'h-11 px-4 text-sm',
        lg: 'h-12 px-6 text-base',
        icon: 'h-11 w-11',
        // A page header's actions (compact chrome, 2026-10-10): 36px with a
        // mouse from lg, 44px on a phone and on any touch screen. The base's
        // min-h-touch is lifted where the height drops and put back on a
        // coarse pointer (density.ts's BUTTON_FIT); twMerge keeps all three.
        bar: 'h-11 px-3 text-sm lg:h-9 lg:min-h-0 [@media(pointer:coarse)]:h-11 [@media(pointer:coarse)]:min-h-touch',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);
